import React from 'react';
import {
  EMAIL_BODY_BUTTON,
  EMAIL_BODY_DIVIDER,
  EMAIL_BODY_IMAGE,
  EMAIL_BODY_TEXT,
} from '../../constants/EmailServicesConst';
import ButtonComponentBox from './services-library/button-component-box/ButtonComponentBox';
import DividerComponentBox from './services-library/divider-component-box/DividerComponentBox';
import ImageComponentBox from './services-library/image-component-box/ImageComponentBox';
import TextComponentBox from './services-library/text-component-box/TextComponentBox';

const EmailBodyComponent = (props) => {
  const { component, componentNdx, onClickComponent, isPreview, onClickRedirectLink } = props;

  const switchComponent = () => {
    switch (component.subId) {
      case EMAIL_BODY_TEXT:
        return (
          <TextComponentBox
            componentObj={{ ...component }}
            onClickComponent={onClickComponent}
            componentNdx={componentNdx}
            isPreview={isPreview}
          />
        );
      case EMAIL_BODY_IMAGE:
        return (
          <ImageComponentBox
            componentObj={{ ...component }}
            onClickComponent={onClickComponent}
            componentNdx={componentNdx}
            isPreview={isPreview}
            onClickRedirectLink={onClickRedirectLink}
          />
        );
      case EMAIL_BODY_BUTTON:
        return (
          <ButtonComponentBox
            componentObj={{ ...component }}
            onClickComponent={onClickComponent}
            componentNdx={componentNdx}
            isPreview={isPreview}
            onClickRedirectLink={onClickRedirectLink}
          />
        );
      case EMAIL_BODY_DIVIDER:
        return (
          <DividerComponentBox
            componentObj={{ ...component }}
            onClickComponent={onClickComponent}
            componentNdx={componentNdx}
            isPreview={isPreview}
          />
        );
      default:
        break;
    }
  };
  return <>{switchComponent()}</>;
};

export default EmailBodyComponent;
